import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m21.542 6.406-2.107-3.334a1.04 1.04 0 0 0-.878-.482H5.442c-.357 0-.691.184-.879.482l-2.11 3.334c-1.088 1.72-.125 4.113 1.908 4.388q.223.03.445.03c.96 0 1.812-.42 2.396-1.066A3.22 3.22 0 0 0 9.6 10.824c.96 0 1.812-.42 2.397-1.066a3.22 3.22 0 0 0 2.396 1.066c.963 0 1.812-.42 2.397-1.066a3.23 3.23 0 0 0 2.841 1.036c2.04-.272 3.007-2.665 1.915-4.388zM19.78 11.96h-.004q-.292.039-.595.04c-.456 0-.893-.07-1.301-.195v4.9H6.118v-4.903a4.4 4.4 0 0 1-1.908.158h-.003a4 4 0 0 1-.442-.085v7.183a2.355 2.355 0 0 0 2.353 2.352h11.763a2.355 2.355 0 0 0 2.352-2.352v-7.183a4 4 0 0 1-.452.085"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }